import { HttpErrorType } from 'types/http.type'
import { AlertColor } from '@mui/material'

export const errorMessage = (error: HttpErrorType) => {
  const message = error.response?.data ? error.response?.data?.message : ''
  return `${message}`
}

export const errorColor = (error: HttpErrorType): AlertColor => {
  const status: number | undefined = error.response.status
  if (status && status >= 500) {
    return 'error'
  } else if (status && status >= 400) {
    return 'warning'
  } else if (status && status >= 200) {
    return 'success'
  } else {
    return 'info'
  }
}
